import { CoreState } from "../../model/common/core.state.model";
import { ReduxAction } from "../../model/redux.action.model";
import {
  CHANGE_NAVIGATION_ENABLED_STATE,
  END_BACKEND_COMMUNICATION, END_NAVIGATION, SET_APP_LOCALE, START_BACKEND_COMMUNICATION,
  START_NAVIGATION
} from "../../action/common/core.action.factory";
import { GET_SUPPORTLINKS_RECEIVE } from "../../action/default/default.action.factory";
import * as _ from "lodash";

export const CORE_STATE_NAME = "core";

export function coreReducer(state: CoreState, action: ReduxAction<any>): CoreState {
  if (!state) {
    state = {
      communicationProgressCount: 0,
      communicationStatus: 0,
      navigationInProgress: false,
      navigationEnabled: true,
      nextNavigationUrl: null,
      currentNavigationUrl: null,
      lastNavigationUrl: null,
      systemDateTime: null,

      locale: null,
      clickToCall: null,
      startChat: null,
      callBack: null
    };
  }

  switch (action.type) {
    case START_BACKEND_COMMUNICATION:
      return changeState(state, {
        communicationProgressCount: state.communicationProgressCount ? state.communicationProgressCount + 1 : 1,
        navigationInProgress: state.navigationInProgress,
        navigationEnabled: state.navigationEnabled
      });
    case END_BACKEND_COMMUNICATION:
      return changeState(state, {
        communicationProgressCount: state.communicationProgressCount ? state.communicationProgressCount - 1 : 0,
        navigationInProgress: state.navigationInProgress,
        navigationEnabled: state.navigationEnabled
      });
    case START_NAVIGATION:
      return changeState(state, {
        navigationInProgress: true,
        communicationProgressCount: state.communicationProgressCount,
        navigationEnabled: state.navigationEnabled
      });
    case END_NAVIGATION:
      return changeState(state, {
        navigationInProgress: false,
        communicationProgressCount: state.communicationProgressCount,
        navigationEnabled: state.navigationEnabled
      });
    case CHANGE_NAVIGATION_ENABLED_STATE:
      return changeState(state, {
        navigationInProgress: state.navigationInProgress,
        communicationProgressCount: state.communicationProgressCount,
        navigationEnabled: action.payload
      });
    case GET_SUPPORTLINKS_RECEIVE:
      if (action.payload) {
        const links = _.reduce(action.payload?.links, function(result, num, key) {
          result[num?.name] = num?.destination;
          return result;
        }, {});
        return changeState(state, links);
      }
      return state;
    case SET_APP_LOCALE:
      if (action.payload) {
        return changeState(state, {
          locale: action.payload
        });
      }
      return state;
    default:
      return state;
  }

  function changeState(originalState: CoreState, changes: Object): CoreState {
    return Object.assign({}, originalState, changes);
  }
}
